module.exports = __webpack_public_path__ + "img/instagram.c5ad0581.png";